import { extendTailwindMerge } from 'tailwind-merge';

/** tailwind-merge that knows our theme colours, so `text-fg-muted` is a colour and not a font size. */
const merge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'page', 'surface', 'surface-sunken', 'hover', 'line', 'line-strong',
        'fg', 'fg-secondary', 'fg-muted', 'grid', 'axis',
        'accent', 'accent-hover', 'accent-contrast', 'accent-wash', 'focus', 'series-1', 'series-1-wash',
        'series-2', 'series-3', 'series-4', 'series-5', 'series-6',
        'band', 'band-raised', 'band-line', 'band-fg', 'band-fg-secondary', 'band-fg-muted', 'band-accent',
        'good', 'warning', 'serious', 'critical', 'neutral',
        'chip-good-bg', 'chip-good-fg', 'chip-warning-bg', 'chip-warning-fg', 'chip-serious-bg', 'chip-serious-fg',
        'chip-critical-bg', 'chip-critical-fg', 'chip-neutral-bg', 'chip-neutral-fg',
      ],
    },
  },
});

/** Joins class names, dropping falsy values; later Tailwind classes override earlier ones. */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return merge(classes.filter(Boolean).join(' '));
}
